import React from 'react';
import { admissionPolicyGuide } from '../../config';

const DoiTuongChinhSachUuTienGuide = () => {
  return (
    <div style={{
      backgroundColor: '#faf5ff',
      border: '1px solid #e9d5ff',
      borderRadius: '8px',
      padding: '20px',
      marginBottom: '24px'
    }}>
      <h3 style={{
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#6b21a8',
        marginBottom: '16px',
        marginTop: 0
      }}>
        Hướng dẫn: Đối tượng chính sách ưu tiên (theo Phụ lục II)
      </h3>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        {/* Group 1 */}
        <div>
          <h4 style={{
            fontWeight: '600',
            color: '#7c3aed',
            marginBottom: '8px',
            marginTop: 0,
            fontSize: '16px'
          }}>
            {admissionPolicyGuide.group1.title}
          </h4>
          <ul style={{
            listStyleType: 'disc',
            paddingLeft: '20px',
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}>
            {admissionPolicyGuide.group1.items.map((item, index) => (
              <li key={index} style={{
                fontSize: '14px',
                color: '#1f2937',
                lineHeight: '1.5'
              }}>
                <span style={{ fontWeight: '500' }}>{item.code}</span> – {item.description}
              </li>
            ))}
          </ul>
        </div>

        {/* Group 2 */}
        <div>
          <h4 style={{
            fontWeight: '600',
            color: '#7c3aed',
            marginBottom: '8px',
            marginTop: 0,
            fontSize: '16px'
          }}>
            {admissionPolicyGuide.group2.title}
          </h4>
          <ul style={{
            listStyleType: 'disc',
            paddingLeft: '20px',
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}>
            {admissionPolicyGuide.group2.items.map((item, index) => (
              <li key={index} style={{
                fontSize: '14px',
                color: '#1f2937',
                lineHeight: '1.5'
              }}>
                <span style={{ fontWeight: '500' }}>{item.code}</span> – {item.description}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <p style={{
        fontSize: '14px',
        color: '#6b7280',
        marginTop: '16px',
        marginBottom: 0,
        fontStyle: 'italic'
      }}>
        Lưu ý: Khi khai báo, bạn cần chuẩn bị giấy tờ chứng minh hợp lệ để được xét ưu tiên. Mỗi đối tượng chỉ được hưởng một loại ưu tiên cao nhất.
      </p>
    </div>
  );
};

export default DoiTuongChinhSachUuTienGuide;
